<ui-form-field-layout
	[isRequired]="isRequired()"
	[title]="title()"
	[subtitle]="subtitle()"
	[isValid]="isValid()"
	[hint]="hint()"
	[suffix]="suffix()"
>
	<div class="ui-input" slot="input">
		<input
			#input
			[ariaLabel]="title()"
			[ngClass]="inputDesignClass()"
			[attr.max]="maxValue()"
			[attr.min]="minValue()"
			type="number"
			[placeholder]="placeholder()"
			autocomplete="off"
			[ngModel]="lastValidValue()"
			(ngModelChange)="handleModelChange($event)"
		/>
	</div>
</ui-form-field-layout>
